import { render } from "./index.vue?vue&type=template&id=3d0c50a0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3d0c50a0&lang=less"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_ygitl4qwkjirupiphave5nrawa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__